export default class CardQuantityDatesDelivery extends HTMLDivElement {
    constructor() {
        super();
        this.quantityLine = this.dataset.quantity ?? 0;
        this.productId = this.dataset.productId;
        this.catalogueId = this.dataset.catalogueId;
        this.spanTotal = this.querySelector('.footer span');
        this.updateRoute = this.dataset.updateRoute;
        this.currentQuantity = 0;
        this._debounceTimer = null;

        this._listeners = { change: null };
    }

    connectedCallback() {
        this.reinit();
    }

    reinit() {
        // (re)snapshot des selectors après toute mutation du DOM
        this.quantitySelector = this.querySelectorAll('quantity-selector');

        // reset listeners pour éviter les doublons
        this._listeners.change?.abort();
        this._listeners.change = new AbortController();

        this.quantitySelector.forEach((selector) => {
            selector.querySelector('input').addEventListener('change', () => {
                clearTimeout(this._debounceTimer);
                this._debounceTimer = setTimeout(() => {
                    this.calculateTotalQuantity(true);
                }, 500); // 300ms de délai, ajustable
            }, { signal: this._listeners.change.signal });
        });

        // recalcul initial (sans sync DB)
        this.calculateTotalQuantity(false);
    }

    calculateTotalQuantity(sync = false) {
        this.currentQuantity = 0;

        this.quantitySelector.forEach((selector) => {
            let inputVal = parseInt(selector.querySelector('input').value, 10) || 0;
            if (inputVal < 0) {
                inputVal = 0;

                selector.querySelector('input').value = inputVal;
            }

            if (inputVal > parseInt(selector.querySelector('input').max, 10)) {
                inputVal = parseInt(selector.querySelector('input').max, 10);

                selector.querySelector('input').value = inputVal;
            }

            this.currentQuantity += inputVal;
        });

        // MEP visuelle
        this.spanTotal.textContent = `${this.currentQuantity}/${this.quantityLine}`;
        const ok = parseInt(this.currentQuantity, 10) === parseInt(this.quantityLine, 10);
        this.classList.toggle('border-2', ok);
        this.classList.toggle('border-success', ok);
        this.classList.toggle('shadow', ok);
        this.spanTotal.classList.toggle('text-success', ok);
        this.spanTotal.classList.toggle('text-danger', !ok);

        // Ajuste les max + build payload
        const datasUpdated = {};
        this.quantitySelector.forEach((selector) => {
            let inputVal = parseInt(selector.querySelector('input').value, 10) || 0;

             // setMax est sur ton custom <quantity-selector>
            const margin = this.quantityLine - this.currentQuantity;
            selector.setMax(ok ? inputVal : inputVal + margin);

            datasUpdated[selector.dataset.date] = {
                delivery_date: selector.dataset.date,
                quantity: inputVal,
                is_exceptional: selector.dataset.exceptional === '1',
            };
        });

        if (sync) this.updateQuantityInDatabase(datasUpdated);
    }

    updateQuantityInDatabase(datasUpdated) {
        fetch(this.updateRoute, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            },
            body: JSON.stringify({ datas_updated: datasUpdated }),
        })
            .then(r => r.json())
            .then(data => { this.refreshTemplates(data.templates); })
            .catch(console.error);
    }

    refreshTemplates(templates) {
        if (typeof templates !== 'object') return;
        for (const [name, content] of Object.entries(templates)) {
            if (typeof content !== 'string') continue;
            const els = document.querySelectorAll(`[data-cart-template="${name}"]`);
            for (const el of els) {
                el.innerHTML = content;

                // Si le HTML rafraîchi contient nos composants, on les “réveille”
                el.querySelectorAll?.('div[is="card-quantity-dates-delivery"]').forEach((node) => {
                    // customElements.upgrade est safe si supporté
                    try { customElements.upgrade?.(node); } catch (_) {}
                    node.reinit?.();
                });
            }
        }
    }
}
